import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AppResource } from 'src/app/app.resource';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { SPECIAL_CONDITIONS_PATH } from 'src/app/shared/constants/route.constants';
import { PolicyState } from 'src/app/shared/enum/policy-state.enum';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { SUBSCRIBER_PATH } from './../../../../shared/constants/route.constants';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';

@Component({
  selector: 'app-e-sign-msg',
  templateUrl: './e-sign-msg.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class ESignMsgComponent extends BaseComponent implements OnInit {
  status: number = 0;
  title: string = '';
  message?: string = '';

  constructor(
    resources: AppResource,
    navigationService: NavigationService,
    private route: ActivatedRoute,
    private router: Router,
    private subscriptionService: SubscriptionService,
  ) {
    super(resources, navigationService);

    this.store.updateVerticalAlign(true);
  }

  override ngOnInit(): void {
    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const statusParam = params.get('status');
      const status = statusParam ? parseInt(statusParam, 10) : NaN;
      this.handleStatus(status);
    });
  }

  private handleStatus(status: number): void {
    if (isNaN(status)) {
      //? TODO: [SIGN-MSG] ➡️ Redirection to change if needed
      this.router.navigate(['product', 'HC']);
    } else if (status === PolicyState.Wait4Sign) {
      this.subscriptionService.nextStep([SUBSCRIBER_PATH, SPECIAL_CONDITIONS_PATH].join('/'));
    } else {
      this.status = status;
      this.setMessage();
    }
  }

  private setMessage(): void {
    switch (this.status) {
      case PolicyState.Signed:
        this.setMessageContent(
          this.resource.signature.signature_msg_title,
          this.resource.signature.signed_message,
        );
        break;
      case PolicyState.Ongoing:
      case PolicyState.Unpaid:
        this.setMessageContent(
          this.resource.signature.signature_msg_title,
          this.resource.signature.ongoing_message,
        );
        break;
      case PolicyState.AutoTerm:
        this.setMessageContent(
          this.resource.signature.signature_msg_title,
          this.resource.signature.auto_term_message,
        );
        break;
      case PolicyState.Suspended:
        this.setMessageContent(
          this.resource.signature.signature_msg_title,
          this.resource.signature.suspended_message,
        );
        break;
      case PolicyState.Na:
      case PolicyState.Terminated:
      case PolicyState.Replaced:
      case PolicyState.Cancelled:
        this.setMessageContent(this.resource.signature.inactive_title);
        break;
      default:
        this.setMessageContent('');
        break;
    }
  }

  private setMessageContent(title: string, message?: string): void {
    this.title = title;
    this.message = message;
  }
}
